/**
 * The main entry point.
 */
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable"; // Added 20 more KBs to the build size. But fixed IE 11.
import React from "react";
import ReactDOM from "react-dom";
import retargetEvents from "react-shadow-dom-retarget-events";
import { StyleSheetManager } from "styled-components";

import * as Sentry from "@sentry/react";

import { Provider } from "react-redux";

import App from "./App";
import { store } from "./store";
import { urlConfig } from "./lib/utils";

if (!urlConfig.staticConfig) {
  Sentry.init({
    release: "chat@2021.01.21",
    ignoreErrors: [
      "top.GLOBALS",
      "$ is not a function",
      "a.parent.postMessage",
      "A.getAll is not a function.",
      "Cannot read property 'offsetWidth' of undefined",
      "undefined is not an object (evaluating 'tiles[0].offsetWidth')",
    ],
    integrations: [
      new Sentry.Integrations.GlobalHandlers({
        onerror: false,
        onunhandledrejection: false,
      }),
    ],
    dsn: "https://43f5c555a3ed40e7b7dfba1e5e24e7bf@sentry.familyassets.com/2",
  });
}

class ShadowDomRetargetedEvents extends HTMLElement {
  constructor() {
    super();
    // Create a shadow root
    const shadowRoot = this.attachShadow({ mode: "open" });

    // Create div element for react to render into
    const reactRoot = document.createElement("div");
    reactRoot.setAttribute("id", "react-root");
    reactRoot.setAttribute("style", "z-index:9999999999999;position:relative;");
    shadowRoot.appendChild(reactRoot);

    const style = document.querySelector("family-assets-chat style");
    if (style) {
      shadowRoot.appendChild(style);
    }

    const styleContainer = document.createElement("div");
    shadowRoot.appendChild(styleContainer);

    // Object.defineProperty(reactRoot, "ownerDocument", { value: shadowRoot });

    ReactDOM.render(
      <Sentry.ErrorBoundary>
        <Provider store={store}>
          <StyleSheetManager target={styleContainer}>
            <App />
          </StyleSheetManager>
        </Provider>
      </Sentry.ErrorBoundary>,
      reactRoot
    );

    retargetEvents(shadowRoot);
  }
}

function main() {
  window.customElements.define("family-assets-chat", ShadowDomRetargetedEvents);
}

if (window.customElements) {
  main();
} else {
  window.addEventListener("WebComponentsReady", function () {
    console.log("webcomponents ready");
    main();
  });
}
